module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1036.fd51d4fc.png";